import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import MainContent from '../components/layout/MainContent';
import Footer from '../components/layout/Footer';
import WhistleBlowerBubble from '../components/common/WhistleBlowerBubble';


const AdminPage: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    // Get active menu from URL or default
    const activeMenu = searchParams.get('view') || 'dashboard';

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleMenuSelect = (menuId: string) => {
        setSearchParams({ view: menuId });
        if (window.innerWidth <= 1024) {
            setSidebarOpen(false);
        }
    };

    return (
        <div className="App">
            <Header
                onToggleSidebar={toggleSidebar}
                sidebarOpen={sidebarOpen}
                onLogoClick={() => setSearchParams({ view: 'dashboard' })}
            />

            <Sidebar
                isOpen={sidebarOpen}
                onMenuSelect={handleMenuSelect}
                activeMenu={activeMenu}
                onToggle={toggleSidebar}
            />

            <MainContent
                activeMenu={activeMenu}
                sidebarOpen={sidebarOpen}
                onNavigate={handleMenuSelect}
                onToggleSidebar={toggleSidebar}
            />

            <Footer />
            <WhistleBlowerBubble />
        </div>
    );
};

export default AdminPage;
